import { playgroundApi } from '../playground/common/api-client';

/**
 * POST a v2 product's own input model straight to its cloud-function route,
 * through the Django proxy at `/api/v1/playground/v2/<slug>/`.
 *
 * Unlike the V1 playground's `/api/v1/playground/projection/`, there is no
 * `product` / `origin_process_id` envelope and no field translation: what the
 * caller passes is what the cloud function validates, so a 422 here points at
 * the product's own pydantic model and nothing in between.
 */
export async function simulateV2Product<TResponse>(
  slug: string,
  payload: unknown,
): Promise<TResponse> {
  const { data } = await playgroundApi.post<TResponse>(`v2/${slug}/`, payload);
  return data;
}
